import { type RouteParams, useMatch } from '@frontend/weave-router';

type SubNavParam = RouteParams<'/bulk_/$subNav'>['subNav'];

/**
 * Returns normalized data from any bulk-messaging route.
 */
export const useBulkUrlData = () => {
  const subNavMatch = useMatch({ from: '/bulk_/$subNav', shouldThrow: false });
  const typeMatch = useMatch({ from: '/bulk_/$subNav_/$type', shouldThrow: false });
  const campaignMatch = useMatch({ from: '/bulk_/$subNav_/$type_/$id', shouldThrow: false });
  const editorMatch = useMatch({ from: '/bulk_/$subNav_/$type_/$id_/$view', shouldThrow: false });

  const params = editorMatch?.params ?? campaignMatch?.params ?? typeMatch?.params ?? subNavMatch?.params;
  const search = editorMatch?.search;

  return {
    campaignId: editorMatch?.params?.id ?? campaignMatch?.params?.id,
    isCopyingAudience: !!search?.copyAudience,
    isEditingTemplate: !!search?.isEdit,
    isSystemTemplate: !!search?.isSystemTemplate,
    isUsingPassedRecipients: !!search?.usePassedRecipients,
    seedCampaignId: search?.seedId,
    startFresh: !!search?.startFresh,
    subNav: isValidSubNav(params?.subNav) ? params.subNav : undefined,
    templateId: search?.templateId,
  };
};

const isValidSubNav = (value: unknown): value is SubNavParam => {
  return value === 'drafts' || value === 'all-campaigns';
};
